import React, { Fragment } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Row, Col } from "reactstrap";
import DataTable from "react-data-table-component";

class CustomTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableHeight: `${window.innerHeight * 0.45}px`,
    };
  }

  updateHeight = () => {
    this.setState({
      tableHeight: `${window.innerHeight * 0.45}px`,
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateHeight);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateHeight);
  }

  render() {
    const {
      columns,
      data,
      errorMessage,
      tableType,
      totalRows,
      rowsPerPage,
      currentPage,
    } = this.props;
    const { tableHeight } = this.state;
    // Determine what to display when there is no data
    const noDataText = errorMessage || "No Data Found";

    return (
      <Fragment>
        <TransitionGroup>
          <CSSTransition
            component="div"
            classNames="TabsAnimation"
            appear={true}
            timeout={1500}
            enter={false}
            exit={false}
          >
            <div>
              <Row>
                <Col md="12">
                  <DataTable
                    columns={columns}
                    data={data}
                    noDataComponent={
                      <div style={{ padding: "24px" }}>{noDataText}</div>
                    }
                    pagination={tableType !== "Significant_Condition"}
                    fixedHeader
                    fixedHeaderScrollHeight={tableHeight}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={rowsPerPage}
                    paginationDefaultPage={currentPage}
                    paginationRowsPerPageOptions={[10, 50, 100]}
                    onChangePage={this.props.handlePageChange}
                    onChangeRowsPerPage={this.props.handleRowsPerPageChange}
                  />
                </Col>
              </Row>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

export default CustomTable;
